import React from "react";
import "./Contact.css";

function Contact() {
  return (
    <div className="contact-page">
      {/* Header Section */}
      <header className="contact-header">
        <div className="header-content">
          <h1>Contact Us</h1>
          <p>We're here to assist you! Feel free to reach out to us anytime.</p>
        </div>
      </header>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container">
          {/* Contact Details */}
          <div className="contact-details">
            <h2>Get in Touch</h2>
            <p>
              Have questions? Need assistance? Reach out to us through any of the following ways:
            </p>
            <ul>
              <li>
                <strong>Email:</strong> support@example.com
              </li>
              <li>
                <strong>Phone:</strong> +123 456 7890
              </li>
              <li>
                <strong>Address:</strong> 123 Main Street, Your City, Your Country
              </li>
            </ul>
          </div>

          {/* Contact Form */}
          <div className="contact-form">
            <h2>Send Us a Message</h2>
            <form>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input type="text" id="name" name="name" placeholder="Your Name" required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input type="email" id="email" name="email" placeholder="Your Email" required />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  placeholder="Your Message"
                  required
                ></textarea>
              </div>
              <button type="submit" className="btn-submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <iframe
          title="Google Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.835434509414!2d144.95565111531707!3d-37.81731397975171!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad642af0f11fd81%3A0xf5771a8fdcde516!2sYour%20Business!5e0!3m2!1sen!2sus!4v1600000000000!5m2!1sen!2sus"
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </section>
    </div>
  );
}

export default Contact;
